/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NestedInResourceId: core.serialization.ObjectSchema<
    serializers.NestedInResourceId.Raw,
    Truvity.NestedInResourceId
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NestedInResourceId {
    export interface Raw {
        values: string[];
    }
}
